import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import KeyCode from "rc-util/lib/KeyCode";
import Animate from "rc-animate";
import LazyRenderBox from "./LazyRenderBox";
import isString from "lodash/isString";
import util from "../../_util/util";
import { DraggableCore } from "react-draggable";
import Loadable from "../../react-loadable";
import WeaLocaleProvider from "../../ecology9/wea-locale-provider";

export function getModuleRender(modules = {}, key, content, context) {
  const module = modules[key];
  if (module) {
    if (typeof module === "function") {
      content = module(context);
    }
    content = module;
  }
  return content;
}

const getLabel = WeaLocaleProvider.getLabel;

let uuid = 0;
let openCount = 0;

// Measure scrollbar width for padding body during modal show/hide
const scrollbarMeasure = {
  position: "absolute",
  top: "-9999px",
  width: "50px",
  height: "50px",
  overflow: "scroll"
};

/* eslint react/no-is-mounted:0 */

function noop() {}

function getScroll(w, top) {
  let ret = w[`page${top ? "Y" : "X"}Offset`];
  const method = `scroll${top ? "Top" : "Left"}`;
  if (typeof ret !== "number") {
    const d = w.document;
    ret = d.documentElement[method];
    if (typeof ret !== "number") {
      ret = d.body[method];
    }
  }
  return ret;
}

function setTransformOrigin(node, value) {
  const style = node.style;
  ["Webkit", "Moz", "Ms", "ms"].forEach(prefix => {
    style[`${prefix}TransformOrigin`] = value;
  });
  style[`transformOrigin`] = value;
}

function offset(el) {
  const rect = el.getBoundingClientRect();
  const pos = {
    left: rect.left,
    top: rect.top
  };
  const doc = el.ownerDocument;
  const w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, 1);
  return pos;
}

const Dialog = React.createClass({
  propTypes: {
    onAfterClose: PropTypes.func,
    onClose: PropTypes.func,
    closable: PropTypes.bool,
    maskClosable: PropTypes.bool,
    visible: PropTypes.bool,
    mousePosition: PropTypes.object,
    wrapStyle: PropTypes.object,
    prefixCls: PropTypes.string,
    wrapClassName: PropTypes.string,
    onSpackClick: PropTypes.func,
    onOk: PropTypes.func,
    onScale: PropTypes.func,
    scalable: PropTypes.bool
  },

  getDefaultProps() {
    return {
      onAfterClose: noop,
      onClose: noop,
      onScale: noop
    };
  },

  getInitialState() {
    this.getInitPosDialog = this.getInitPosDialog.bind(this);
    return {
      // drgX: 0,
      // drgY: 0,
      draggableKey: `draggable-${new Date().getTime()}`,
      x: 0,
      y: 0,
      initPosDialog: null,
      scaleState: false,
      dialogTop: undefined,
      dialogLeft: undefined,
      bodyHeight: undefined
    };
  },

  componentWillMount() {
    this.titleId = `rcDialogTitle${uuid++}`;
  },

  componentDidMount() {
    this.componentDidUpdate({});
    this.getInitPosDialog();
  },
  componentWillReceiveProps(nextProps, nextState) {
    if ("visible" in nextProps && this.props.visible !== nextProps.visible) {
      if (!nextProps.visible) {
        // this.setState({drgX: 0, drgY: 0});
        this.removeScrollingEffect();
        this.setState({ scaleState: false });
      } else {
        this.addScrollingEffect();
      }
    }
  },
  componentDidUpdate(prevProps) {
    const props = this.props;
    const mousePosition = this.props.mousePosition;
    const dialogNode = ReactDOM.findDOMNode(this.refs.dialog);
    if (props.visible) {
      // first show
      if (!prevProps.visible) {
        // this.refs.draggable.setState({x: 0, y: 0});
        this.lastOutSideFocusNode = document.activeElement;
        this.addScrollingEffect();
        this.refs.wrap.focus();
        // if (mousePosition) {
        //   const elOffset = offset(dialogNode);
        //   setTransformOrigin(dialogNode,
        //     `${mousePosition.x - elOffset.left}px ${mousePosition.y - elOffset.top}px`);
        // } else {
        //   setTransformOrigin(dialogNode, '');
        // }
      }
    } else if (prevProps.visible) {
      dialogNode.style["transform"] = "none";
      this.setState({ draggableKey: `draggable-${new Date().getTime()}` });
      // this.refs.draggable.setState({x: 0, y: 0});
      if (props.mask && this.lastOutSideFocusNode) {
        try {
          this.lastOutSideFocusNode.focus();
        } catch (e) {
          this.lastOutSideFocusNode = null;
        }
        this.lastOutSideFocusNode = null;
      }
    }
  },

  onAnimateLeave() {
    // need demo?
    // https://github.com/react-component/dialog/pull/28
    if (this.refs.wrap) {
      this.refs.wrap.style.display = "none";
    }
    this.removeScrollingEffect();
    this.props.onAfterClose();
  },

  onMaskClick(e) {
    if (
      e.target === e.currentTarget &&
      this.props.closable &&
      this.props.maskClosable
    ) {
      this.close(e);
    }
  },

  onKeyDown(e) {
    const props = this.props;
    if (props.closable && props.keyboard) {
      if (e.keyCode === KeyCode.ESC) {
        this.close(e);
      }
    }
    // keep focus inside dialog
    if (props.visible) {
      if (e.keyCode === KeyCode.TAB) {
        const activeElement = document.activeElement;
        const dialogRoot = this.refs.wrap;
        const sentinel = this.refs.sentinel;
        if (e.shiftKey) {
          if (activeElement === dialogRoot) {
            sentinel.focus();
          }
        } else if (activeElement === this.refs.sentinel) {
          dialogRoot.focus();
        }
      }

      if (e.keyCode === KeyCode.SPACE) {
        props.onSpackClick && props.onSpackClick(e);
      }

      if (e.KeyCode === KeyCode.ENTER) {
        props.onOk && props.onOk(e);
      }
    }
  },
  getInitPosDialog() {
    // setTimeOut，添加到事件队列去执行，可以准确获取窗口初始化的位置状态
    const dom = $(this.refs.wrap).find(".ant-modal")[0];
    if (!dom) {
      return;
    }
    setTimeout(() => {
      const posDialog = dom.getBoundingClientRect();
      this.setState({
        firstPosDialog: posDialog
      });
    }, 0);
  },
  onStartDrag(e, position) {
    const dom = $(this.refs.wrap).find(".ant-modal")[0];
    if (!dom) {
      return;
    }
    const originTransform = $(dom)
      .css("transform")
      .split(",");
    //  ["matrix(1", " 0", " 0", " 1", " 7", " -4)"]
    const nowTransform = { x: 0, y: 0 };
    if (originTransform.length === 6) {
      nowTransform.x = parseInt(originTransform[4], 10);
      nowTransform.y = parseInt(originTransform[5], 10);
    }

    const posDialog = dom.getBoundingClientRect();
    this.setState({
      initPosDialog: posDialog,
      posOffset: nowTransform,
      initPos: {
        x: position.x,
        y: position.y
      }
    });
  },
  handleDrag(e, position) {
    const dom = $(this.refs.wrap).find(".ant-modal")[0];
    const posDialog = dom.getBoundingClientRect();
    // const posOffset = position;
    const { initPosDialog, initPos, posOffset, firstPosDialog } = this.state;

    if (!firstPosDialog) {
      return;
    }

    const browserSize = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    const hideRate = 0.8;
    const cursorOffset = {
      x: initPos.x - initPosDialog.x,
      y: initPos.y - initPosDialog.y
    };
    // console.log(cursorOffset);
    let newX = e.clientX - initPos.x + posOffset.x;
    let newY = e.clientY - initPos.y + posOffset.y;
    // console.log('mouse', e.clientX, e.clientY, 'mouse down', initPos.x, initPos.y, 'offset', posOffset.x, posOffset.y)
    // console.log('initposdia', initPosDialog)
    const limitedPoint = {
      x: e.clientX - cursorOffset.x,
      y: e.clientY - cursorOffset.y
    };
    if (limitedPoint.x < -posDialog.width * hideRate) {
      newX = -firstPosDialog.x - posDialog.width * hideRate;
    }
    if (limitedPoint.x > browserSize.width - posDialog.width * (1 - hideRate)) {
      newX =
        -firstPosDialog.x +
        browserSize.width -
        posDialog.width * (1 - hideRate);
    }
    if (limitedPoint.y < 0) {
      newY = -firstPosDialog.y;
    }
    if (
      limitedPoint.y >
      browserSize.height - posDialog.height * (1 - hideRate)
    ) {
      newY =
        -firstPosDialog.y +
        browserSize.height -
        posDialog.height * (1 - hideRate);
    }
    newX = Math.floor(newX);
    newY = Math.floor(newY);
    // console.log(newX, newY);
    $(dom).css("transform", `translate(${newX}px, ${newY}px)`);
    // this.setState({ x: newX, y: newY });
  },
  setBodyHeight(ref) {
    if (!ref) return;
    const { scalable } = this.props;
    const { scaleState } = this.state;
    if (
      scalable &&
      scaleState &&
      this.refs.dialog &&
      this.refs.dialog.refs.renderBox
    ) {
      const dHeight = this.refs.dialog.refs.renderBox.clientHeight;
      const hHeight = this.refs.header ? this.refs.header.clientHeight : 0;
      const fHeight = this.refs.footer ? this.refs.footer.clientHeight : 0;
      ref.style.height = `${dHeight - hHeight - fHeight}px`;
    }
  },
  getDialogHeader(modules) {
    const props = this.props;
    const { prefixCls, draggable = true } = props;
    const nodrag = util.isBelowIE9() || !draggable; // IE9 暂时不让拖拽
    const module_1_1 = getModuleRender(
      modules,
      "module_1_1",
      props.title,
      this
    );
    let module_1;
    if (module_1_1) {
      module_1 = (
        <div className={`${prefixCls}-header`} ref="header">
          <div
            className={`${prefixCls}-title ${nodrag ? "" : "cursor-move"}`}
            id={this.titleId}
          >
            {module_1_1}
          </div>
        </div>
      );
    }
    module_1 = getModuleRender(modules, "module_1", module_1, this);
    return {
      module_1,
      module_1_1
    };
  },
  getDialogContent(modules) {
    const { scaleState, bodyHeight } = this.state;
    const props = this.props;
    const { scalable, closable, prefixCls } = props;
    let scaleBodyStyle = {};
    if (scalable) {
      if (!scaleState) {
        scaleBodyStyle = {
          ...scaleBodyStyle,
          height: `${bodyHeight}px`
        };
      }
    }
    const bodyStyle = {
      ...props.bodyStyle,
      ...scaleBodyStyle
    };
    let module_2 = (
      <div
        className={`${prefixCls}-body ${
          scalable ? `${prefixCls}-body-scalable` : ""
        }`}
        style={bodyStyle}
        ref="body"
      >
        {props.children}
      </div>
    );
    module_2 = getModuleRender(modules, "module_2", module_2, this);
    let module_3 = props.footer;
    if (module_3) {
      module_3 = (
        <div className={`${prefixCls}-footer`} ref="footer">
          {isString(module_3) ? (
            <div dangerouslySetInnerHTML={{ __html: module_3 }} />
          ) : (
            module_3
          )}
        </div>
      );
    }
    module_3 = getModuleRender(modules, "module_3", module_3, this);
    let module_4;
    if (closable) {
      module_4 = (
        <span
          ecId={`${this.props.ecId}_span@ekl553`}
          onClick={this.close}
          className={`${prefixCls}-close`}
        >
          <span className={`${prefixCls}-close-x`} />
        </span>
      );
    }
    module_4 = getModuleRender(modules, "module_4", module_4, this);
    return {
      ...this.getDialogHeader(modules),
      module_2,
      module_3,
      module_4
    };
  },
  getDialogElement() {
    const { draggableKey, scaleState, dialogTop, dialogLeft } = this.state;
    const props = this.props;
    const { draggable = true, scalable, prefixCls } = props;
    const nodrag = util.isBelowIE9() || !draggable; // IE9 暂时不让拖拽
    const dest = {};
    if (props.width !== undefined) {
      dest.width = props.width;
    }
    if (props.height !== undefined) {
      dest.height = props.height;
    }
    let scale;
    let scaleStyle = {};
    if (scalable) {
      scale = (
        <span
          ecId={`${this.props.ecId}_span@prshhj`}
          onClick={this.scale}
          className={`${prefixCls}-scale`}
        >
          <icon
            className={`${
              scaleState
                ? "icon-coms-All-contraction"
                : "icon-coms-All-unfolding"
            }`}
            title={
              scaleState ? getLabel(589, "还原") : getLabel(19944, "最大化")
            }
          />
        </span>
      );
      if (scaleState) {
        scaleStyle = {
          ...scaleStyle,
          height: "100%",
          width: "100%",
          left: 0,
          top: 0,
          paddingBottom: 0,
          transform: "" // 清除拖拽位移
        };
      } else {
        scaleStyle = {
          ...scaleStyle,
          top: dialogTop,
          left: dialogLeft
        };
      }
    }
    let module_5 = getModuleRender(modules, "module_5", scale, this);
    const style = {
      ...props.style,
      ...dest,
      ...scaleStyle
    };
    const transitionName = this.getTransitionName();
    let modules = this.getDialogContent();
    if (typeof props.getRenderModule === "function") {
      modules = props.getRenderModule(this, { ...modules, module_5 }) || {};
      module_5 = modules.module_5 || module_5;
      modules = this.getDialogContent(modules);
    }
    const { module_1, module_2, module_3, module_4 } = modules;
    const dialogElement = nodrag ? (
      <LazyRenderBox
        ecId={`${this.props.ecId}_LazyRenderBox@3puw9j`}
        role="document"
        ref="dialog"
        style={style}
        className={`${prefixCls} ${props.className || ""}`}
        visible={props.visible}
        resize={props.resize}
      >
        <div
          className={`${prefixCls}-content ${
            scaleState ? `${prefixCls}-content-scaled` : ""
          }`}
        >
          {module_5}
          {module_4}
          {module_1}
          {module_2}
          {module_3}
        </div>
        <div
          tabIndex="0"
          ref="sentinel"
          style={{ width: 0, height: 0, overflow: "hidden" }}
        >
          sentinel
        </div>
      </LazyRenderBox>
    ) : (
      <DraggableCore
        ecId={`${this.props.ecId}_DraggableCore@3ha0pj`}
        handle=".ant-modal-title"
        ref="draggable"
        key={draggableKey}
        // position={{ x: this.state.x, y: this.state.y }}
        onDrag={scalable && scaleState ? noop : this.handleDrag.bind(this)}
        onStart={scalable && scaleState ? noop : this.onStartDrag.bind(this)}
      >
        <LazyRenderBox
          ecId={`${this.props.ecId}_LazyRenderBox@jdqr1b`}
          role="document"
          ref="dialog"
          style={style}
          className={`${prefixCls} ${props.className || ""}`}
          visible={props.visible}
          resize={props.resize}
        >
          <div
            className={`${prefixCls}-content ${
              scaleState ? `${prefixCls}-content-scaled` : ""
            }`}
          >
            {module_5}
            {module_4}
            {module_1}
            {module_2}
            {module_3}
          </div>
          <div
            tabIndex="0"
            ref="sentinel"
            style={{ width: 0, height: 0, overflow: "hidden" }}
          >
            sentinel
          </div>
        </LazyRenderBox>
      </DraggableCore>
    );

    return !props.disableAnimate ? (
      <Animate
        ecId={`${this.props.ecId}_Animate@naejrk`}
        key="dialog"
        showProp="visible"
        onLeave={this.onAnimateLeave}
        transitionName={transitionName}
        component=""
        transitionAppear
      >
        {dialogElement}
      </Animate>
    ) : (
      dialogElement
    );
  },

  getZIndexStyle() {
    const style = {};
    const props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  },

  getWrapStyle() {
    return {
      ...this.getZIndexStyle(),
      ...this.props.wrapStyle
    };
  },

  getMaskElement() {
    const props = this.props;
    let maskElement;
    if (props.mask) {
      const maskTransition = this.getMaskTransitionName();
      maskElement = (
        <LazyRenderBox
          ecId={`${this.props.ecId}_LazyRenderBox@b7ryhq`}
          style={this.getZIndexStyle()}
          key="mask"
          className={`${props.prefixCls}-mask`}
          hiddenClassName={`${props.prefixCls}-mask-hidden`}
          visible={props.visible}
        />
      );
      if (maskTransition) {
        maskElement = (
          <Animate
            ecId={`${this.props.ecId}_Animate@2e4ywr`}
            key="mask"
            showProp="visible"
            transitionAppear
            component=""
            transitionName={maskTransition}
          >
            {maskElement}
          </Animate>
        );
      }
    }
    return maskElement;
  },

  getMaskTransitionName() {
    const props = this.props;
    let transitionName = props.maskTransitionName;
    const animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = `${props.prefixCls}-${animation}`;
    }
    return transitionName;
  },

  getTransitionName() {
    const props = this.props;
    let transitionName = props.transitionName;
    const animation = props.animation;
    if (!transitionName && animation) {
      transitionName = `${props.prefixCls}-${animation}`;
    }
    return transitionName;
  },

  getElement(part) {
    return this.refs[part];
  },

  setScrollbar() {
    if (this.bodyIsOverflowing && this.scrollbarWidth) {
      document.body.style.paddingRight = `${this.scrollbarWidth}px`;
    }
  },

  addScrollingEffect() {
    document.body.style.overflow = "hidden";
    openCount++;
    if (openCount !== 1) {
      return;
    }
    this.checkScrollbar();
    this.setScrollbar();
    // this.adjustDialog();
  },

  removeScrollingEffect() {
    document.body.style.overflow = "";
    openCount--;
    if (openCount !== 0) {
      return;
    }
    this.resetScrollbar();
    // this.resetAdjustments();
  },

  close(e) {
    // reset modal drag position
    // this.setState({drgX:0, drgY:0});
    // $(this.refs.dialog).css('transform', 'none');
    this.removeScrollingEffect();
    this.setState({ scaleState: false });
    this.props.onClose(e);
    typeof this.props.onAfterClose === "function" && this.props.onAfterClose();
  },

  scale(e) {
    const { scaleState, dialogTop, dialogLeft, bodyHeight } = this.state;
    let newState = {};
    // 保留原始位置
    if (!scaleState && this.refs.dialog && this.refs.dialog.refs.renderBox) {
      const box = this.refs.dialog.refs.renderBox;
      const top = box.style.top;
      const left = box.style.left;
      if (top !== dialogTop || left !== dialogLeft) {
        newState = {
          ...newState,
          dialogTop: top,
          dialogLeft: left
        };
      }
      box.style.transition = "all .3s ease-in-out";
    }
    if (!scaleState && this.refs.body) {
      const body = this.refs.body;
      const height = body.clientHeight;
      if (height !== bodyHeight) {
        newState = {
          ...newState,
          bodyHeight: height
        };
      }
    }
    this.setState({ ...newState, scaleState: !scaleState }, () => {
      if (this.refs.body) {
        if (!scaleState) {
          this.setBodyHeight(this.refs.body);
        }
      }
      if (this.refs.dialog && this.refs.dialog.refs.renderBox && scaleState) {
        setTimeout(() => {
          this.refs.dialog.refs.renderBox.style.transition = "";
        }, 300);
      }
      this.props.onScale(
        e,
        !scaleState,
        scaleState ? bodyHeight : this.refs.body.clientHeight
      );
    });
  },

  checkScrollbar() {
    let fullWindowWidth = window.innerWidth;
    if (!fullWindowWidth) {
      // workaround for missing window.innerWidth in IE8
      const documentElementRect = document.documentElement.getBoundingClientRect();
      fullWindowWidth =
        documentElementRect.right - Math.abs(documentElementRect.left);
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
    if (this.bodyIsOverflowing) {
      this.scrollbarWidth = this.measureScrollbar();
    }
  },
  resetScrollbar() {
    document.body.style.paddingRight = "";
  },

  measureScrollbar() {
    if (this.scrollbarWidth !== undefined) {
      return this.scrollbarWidth;
    }
    const scrollDiv = document.createElement("div");
    for (const scrollProp in scrollbarMeasure) {
      if (scrollbarMeasure.hasOwnProperty(scrollProp)) {
        scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
      }
    }
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    this.scrollbarWidth = scrollbarWidth;
    return scrollbarWidth;
  },

  adjustDialog() {
    if (this.refs.wrap && this.scrollbarWidth) {
      const modalIsOverflowing =
        this.refs.wrap.scrollHeight > document.documentElement.clientHeight;
      this.refs.wrap.style.paddingLeft = `${
        !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : ""
      }px`;
      this.refs.wrap.style.paddingRight = `${
        this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ""
      }px`;
    }
  },

  resetAdjustments() {
    if (this.refs.wrap) {
      this.refs.wrap.style.paddingLeft = this.refs.wrap.style.paddingLeft = "";
    }
  },
  render() {
    const props = this.props;
    const prefixCls = props.prefixCls;
    const style = this.getWrapStyle();
    // clear hide display
    // and only set display after async anim, not here for hide
    if (props.visible) {
      style.display = null;
    } else {
      style.display = "none";
    }
    return (
      <div className={`${props.parentClassName}`}>
        {this.getMaskElement()}
        <div
          ecId={`${this.props.ecId}_div@pk1lua`}
          tabIndex="-1"
          onKeyDown={this.onKeyDown}
          className={`${prefixCls}-wrap ${props.wrapClassName || ""}`}
          ref="wrap"
          onClick={this.onMaskClick}
          role="dialog"
          aria-labelledby={props.title ? this.titleId : null}
          style={style}
        >
          {this.getDialogElement()}
        </div>
      </div>
    );
  }
});

export default Dialog;



// WEBPACK FOOTER //
// ./_rc-dialog-6.1.1/src/Dialog.jsx